import { api } from "./api";

export const courseIndex = api.injectEndpoints({
    endpoints: (builder) => ({
        getCourseIndex: builder.query<any, void>({
            query: () => ({
                url: "/CourseIndex/CourseIndex",
                method: "GET",
            }),
            providesTags: ["CourseIndex"]
        })
    })
})

export const { useGetCourseIndexQuery, useLazyGetCourseIndexQuery } = courseIndex;